import {
  FormControlLabel as UnstyledFormControlLabel,
  styled,
} from "@mui/material";
import type { ComponentPropsWithRef } from "react";

interface FormControlLabelProps extends ComponentPropsWithRef<
  typeof UnstyledFormControlLabel
> {
  fullWidth?: boolean;
}

export const FormControlLabel = styled(UnstyledFormControlLabel, {
  shouldForwardProp: (propName: keyof FormControlLabelProps) =>
    propName !== "fullWidth",
})<FormControlLabelProps>(({ fullWidth }) =>
  fullWidth
    ? {
        display: "flex",
      }
    : null,
);
